import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/services', label: 'Services' },
  { path: '/sectors', label: 'Sectors' },
  { path: '/jobs', label: 'Jobs' },
  { path: '/employers', label: 'Employers' },
  { path: '/contact', label: 'Contact' },
];

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [candidateUser, setCandidateUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('candidateToken');
    const user = localStorage.getItem('candidateUser');
    if (token && user) {
      setIsAuthenticated(true);
      setCandidateUser(JSON.parse(user));
    }
  }, []);

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <span>📞 <a href="tel:+44000000000">Call Us Today</a></span>
            <span>✉️ <a href="mailto:info@horizonrecruitmentltd.co.uk">info@horizonrecruitmentltd.co.uk</a></span>
          </div>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            <span>Mon-Fri: 7:00 AM - 6:00 PM</span>
            <span>|</span>
            <span>24/7 Emergency Line Available</span>
          </div>
        </div>
      </div>

      <div className="header-main">
        <div className="container">
          <div className="logo" onClick={() => { navigate('/'); setMobileOpen(false); }}>
            <div className="logo-icon">H</div>
            <div className="logo-text">
              <h2>Horizon</h2>
              <span>Recruitment Ltd</span>
            </div>
          </div>

          <nav className={`nav ${mobileOpen ? 'mobile-open' : ''}`}>
            {navLinks.map(link => (
              <a
                key={link.path}
                href={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(link.path);
                  setMobileOpen(false);
                }}
              >
                {link.label}
              </a>
            ))}
            
            {isAuthenticated ? (
              <a
                href="/dashboard"
                className="nav-link nav-cta"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/dashboard');
                  setMobileOpen(false);
                }}
              >
                👤 {candidateUser?.firstName || 'Dashboard'}
              </a>
            ) : (
              <>
                <a
                  href="/login"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/login');
                    setMobileOpen(false);
                  }}
                >
                  Login
                </a>
                <a
                  href="/register"
                  className="nav-link nav-cta"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/register');
                    setMobileOpen(false);
                  }}
                >
                  Sign Up
                </a>
              </>
            )}
          </nav>

          <button
            className="mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </header>
  );
}
